"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableRow = exports.CardCol = void 0;

var _card = require("../card");

var _context = require("../context");

var _layout = require("../layout");

var CardCol = _card.Card.withComponent(_layout.Col, {
  target: "edbdntt0"
});

exports.CardCol = CardCol;
var ClickableRow = (0, _context.styledWithTheme)(_layout.Row)({
  cursor: 'pointer'
});
exports.ClickableRow = ClickableRow;